/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SiteNavDropdownContent_navigationModule$ref = any;
export type SiteNavItem_navigationModule$ref = any;
export type SiteNavItem_navigationModule = {
    readonly imageLink: string | null;
    readonly name: string | null;
    readonly isLinkable: boolean | null;
    readonly url: string | null;
    readonly isHighlighted: boolean | null;
    readonly items?: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly name: string | null;
        readonly column: string | null;
        readonly items: ReadonlyArray<{
            readonly serviceId: string | null;
            readonly name: string | null;
            readonly isLinkable: boolean | null;
            readonly url: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": SiteNavDropdownContent_navigationModule$ref;
    readonly " $refType": SiteNavItem_navigationModule$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isLinkable",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "SiteNavItem_navigationModule",
        "type": "NavigationModule",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "fetchSubNav",
                "type": "Boolean"
            }
        ],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "imageLink",
                "args": null,
                "storageKey": null
            },
            (v0 /*: any*/),
            (v1 /*: any*/),
            (v2 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isHighlighted",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "FragmentSpread",
                "name": "SiteNavDropdownContent_navigationModule",
                "args": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "fetchSubNav",
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "items",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "NavigationTopLevel",
                        "plural": true,
                        "selections": [
                            (v3 /*: any*/),
                            (v0 /*: any*/),
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "column",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "items",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "NavigationItem",
                                "plural": true,
                                "selections": [
                                    (v3 /*: any*/),
                                    (v0 /*: any*/),
                                    (v1 /*: any*/),
                                    (v2 /*: any*/)
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'b3d891b71efec613cfd2d738466e0686';
export default node;
